/**
 * Get redirect URL for user logged out
 */
export const getQsRedirectUrlUserLoggedOut = (): string => {
  const currentUrl = window.location.pathname + window.location.search;
  return currentUrl !== '/sign-in' ? `?redirect=${encodeURIComponent(currentUrl)}` : '';
};

/**
 * Update URL search parameters while preserving others
 */
export const updateUrlParams = (
  searchParams: URLSearchParams,
  updates: Record<string, string | null>,
  resetPage: boolean = true
): URLSearchParams => {
  const params = new URLSearchParams(searchParams);
  
  // Apply updates
  Object.entries(updates).forEach(([key, value]) => {
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
  });
  
  // Reset to page 1 if requested
  if (resetPage) {
    params.set('page', '1');
  }
  
  return params;
};

/**
 * Clear all filters from URL params except page
 */
export const clearAllUrlFilters = (): URLSearchParams => {
  const params = new URLSearchParams();
  params.set('page', '1');
  return params;
};

/**
 * Check if any filters are active (non-default values)
 */
export const hasActiveFilters = (
  searchQuery: string,
  typeFilter: string,
  statusFilter: string,
  assignedFilter: string,
  defaultTypeFilter: string = 'contact'
): boolean => {
  return !!(
    searchQuery || 
    typeFilter !== defaultTypeFilter || 
    statusFilter || 
    assignedFilter
  );
};